import gql from "graphql-tag";

export default class QueryChronology {
  public static getCarteChronologyListing() {
    return gql`
      query getCarteChronologyListing($language: String!) {
        getCarteChronologyListing(defaultLanguage: $language) {
          edges {
            node {
              id
              video {
                ... on asset {
                  fullpath
                }
              }
            }
          }
        }
      }
    `;
  }
}
